var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitIc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    alt: "Cerrar",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cerrar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-OV-CECEU---Desktop-CAMBIOS-ENE21",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main---Ayuda",
    transform: "translate(-36.000000, -299.000000)",
    fill: "#087021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "exit_ic",
    transform: "translate(36.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0142117,5.02776525 C19.3795122,5.11563706 19.664731,5.40085584 19.7526028,5.76615642 C19.8404746,6.13145699 19.7161689,6.51518551 19.4307927,6.75957539 L13.77,12.419 L19.4307927,18.0795754 C19.7161689,18.3239653 19.8404746,18.7076938 19.7526028,19.0729944 C19.664731,19.4382949 19.3795122,19.7235137 19.0142117,19.8113855 C18.6489111,19.8992573 18.2651826,19.7749515 18.0207927,19.4895754 L12.36,13.829 L6.7007927,19.4895754 C6.31075524,19.877299 5.68083015,19.877299 5.2907927,19.4895754 C4.9030691,19.0995379 4.9030691,18.4696128 5.2907927,18.0795754 L10.95,12.419 L5.2907927,6.75957539 C4.9030691,6.36953794 4.9030691,5.73961284 5.2907927,5.34957539 C5.68083015,4.9618518 6.31075524,4.9618518 6.7007927,5.34957539 L12.36,11.009 L18.0207927,5.34957539 C18.2651826,5.06419923 18.6489111,4.93989345 19.0142117,5.02776525 Z",
    id: "\\uD83C\\uDF08Icon"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitIc);
export default __webpack_public_path__ + "static/media/exit_ic.784c76f0.svg";
export { ForwardRef as ReactComponent };